import axiosInstance from '../../../axiosInstance2'
import apiEndpoints from '../../../api'
import { notify } from '../../../../utils/notification'

export const getProfileReq = (action) => {
    return axiosInstance.get(apiEndpoints.CTRL_GET_PROFILE_API)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const updateProfileReq = (action) => {
    const body = {
        first_name: action?.data?.first_name,
        last_name: action?.data?.last_name,
        phone: action?.data?.phone,
    }
    return axiosInstance.put(apiEndpoints.CTRL_UPDATE_PROFILE_API, { ...body })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const changePasswordReq = (action) => {
    const body = {
        current_password: action?.data?.currentPassword,
        new_password: action?.data?.newPassword
    };

    return axiosInstance.post(apiEndpoints.CTRL_CHANGE_PASSWORD, { ...body })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}
